<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vii" class="page" epub:type="pagebreak" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf"><a class="xref" href="#/chikuklick0008#intro">Introduction: Expressing Fascism</a></p>
<p class="tocpt"><a class="xref" href="#/chikuklick0009#pt01"><span class="sm">PART</span> <span class="sm">I</span>: 1909–49</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0010#pt01t">Why Fascism?</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0011#ch01">1  Fascism before Fascism, 1909–35</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0012#ch02">2  Franklin Roosevelt and Political Culture, 1932–36</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0013#ch03">3  Perplexity at Home and Abroad, 1934–38</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0014#ch04">4  Foreign and Domestic Contradictions, 1938–40</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0015#ch05">5  The Coming of the War, 1939–42</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0016#ch06">6  Fascism Penetrates Popular Life, 1936–49</a></p>
<p class="tocpt"><a class="xref" href="#/chikuklick0017#pt02"><span class="sm">PART</span> <span class="sm">II</span>: 1942–2020</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0018#pt02t">Performing Words</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0019#ch07">7  Fascism on the Right, 1942–70</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0020#ch08">8  Europeans Bring Fascism to the States</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0021#ch09">9  Fascism Triumphs over Communism</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0022#ch10">10  Scholars Approach Fascism</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0023#ch11">11  Fascism Everywhere, 1970–2020</a></p>
<p class="toc"><a class="xref" href="#/chikuklick0024#ch12">12  Democracy and Fascism</a></p>
<p class="tocf"><a class="xref" href="#/chikuklick0025#conc">Conclusion: Fascism without Fascism</a></p>
<p class="tocbmf"><a class="xref" href="#/chikuklick0026#sources">Notes, Sources, and Methods</a></p>
<p class="tocbm"><a class="xref" href="#/chikuklick0027#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chikuklick0028#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chikuklick0029#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-kuklick-0007.vue?4def73e6